let options = {
  "muted": false,
  "cc": false
}

export {options}
